<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { titleClasses, BASE_CLASS } from './variant'

const props = withDefaults(
  defineProps<{
    class?: HTMLAttributes['class']
    title: string
    titleAs?: string | Component
    center?: boolean
    description?: string
    descriptionClass?: HTMLAttributes['class']
    subTitle?: string
    subTitleAs?: string | Component
    subTitleClass?: HTMLAttributes['class']
    variantSize?: keyof typeof titleClasses
    viewTransition?: boolean
  }>(),
  {
    titleAs: undefined,
    class: undefined,
    description: undefined,
    descriptionClass: undefined,
    center: false,
    subTitleClass: undefined,
    subTitle: undefined,
    subTitleAs: undefined,
    variantSize: 'default',
    viewTransition: false
  }
)

const isCentered = computed(
  () => cn(props.class)?.includes('text-center') || props.center
)
</script>

<template>
  <div
    :class="
      cn(
        'flex flex-col items-start gap-2 lg:gap-3',
        {
          'items-center text-center mx-auto': isCentered
        },
        props.class
      )
    "
  >
    <UiSectionSubtitle
      v-if="props.subTitle"
      :text="props.subTitle"
      :as="props.subTitleAs"
      :class="props.subTitleClass"
      :view-transition="props.viewTransition"
    />

    <div
      class="flex flex-col gap-3"
      :class="{
        'items-center': isCentered
      }"
    >
      <component
        :is="props.titleAs ?? 'h2'"
        :class="cn(BASE_CLASS, titleClasses[props.variantSize])"
        :style="
          props.viewTransition ? { viewTransitionName: 'section-title' } : {}
        "
      >
        <span v-html="props.title"></span>
      </component>
      <UiSectionDescription
        v-if="props.description"
        :class="props.descriptionClass"
        :center="isCentered"
        :text="props.description"
        :view-transition="props.viewTransition"
      />
    </div>
  </div>
</template>
